<template>
  <div id="app" >
    <el-container >
      <el-header >
        <top-search></top-search>
        <top-bar></top-bar>
      </el-header>
      <el-main id="main">
          <router-view /> 
      </el-main>
      <el-footer id="footer">
        <footer-bar></footer-bar>
      </el-footer>
    </el-container>

    <!-- <nav> -->
    <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
    <!-- </nav> -->
    <!-- <router-view/> -->
  </div>
</template>
<script>
import TopSearch from "@/components/common/topsearch/TopSearch.vue";
import TopBar from "@/components/common/topbar/TopBar.vue";
import FooterBar from "@/components/common/footer/Footer.vue";
import $ from 'jquery';
import { computed } from 'vue';
export default {
  components: {
    TopSearch,
    TopBar,
    FooterBar,
  },
  data(){
    return{
    }
  },
  mounted(){
    // this.mainHeight = this.$refs.getHeight.$el.offsetHeight +'px';
    // console.log(this.$refs.aaaa.$el.offsetHeight);
    // // console.log(document.documentElement.clientHeight);
    // console.log(document.body.offsetHeight);
    let minHeight = window.innerHeight -260;
    let footHeight = $("#footer").height();
    console.log(footHeight)
    $("#app").css("minHeight",minHeight)
    // console.log($('#main').height());
    // this.mainHeight = this.$refs.aaaa.$el.offsetHeight+"px"
    
  },
  beforeCreate(){
   
  },
  created(){
    let lang = localStorage.getItem('lang')
    if(lang == null){
      localStorage.setItem('lang','zh-CN');
      document.title="深圳市思博高电子有限公司"
    }else if(lang == 'zh-EN'){
      document.title="Snow Electronics(HK) Limited"
    }else if(lang == 'zh-KN'){
      document.title="선전시 쓰보 전자 유한회사"

    }
  }
};
</script>

<style lang="less" scoped>
 @import './assets/css/base.css';
#app{
  position:relative;
  padding-bottom: 100px;
}
/deep/ .el-header{
  padding: 0px;
  // position: sticky;
  // top: 0px;
  // z-index: 99;

}
/deep/ .el-main{
  padding: 0;
  margin-top: 79px
}

/deep/ .el-footer{
  padding: 0;
  position: absolute;
  bottom:0;
  left:0;
  right:0;
}
</style>
